import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import '../../../css/SubscriptionFee/PaymentDetails.css';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL, utilityBaseURL } from '../../../Services/config/apiGateway';
import { SUBSCRIPTION_HISTORY_ENDPOINT, DOCUMENT_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import download from '../../../Assets/TruckVisits/Assets/download.svg';
import { store } from '../../../Redux/_helpers/store';
import { Link } from 'react-router-dom';
import { successLoader, } from '../../../Redux/_actions/loader.action';
import Cookies from 'cookies-js';

class PaymentDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            paymentHistoryDetail: {},
            documentURL: utilityBaseURL + DOCUMENT_ENDPOINT + "?documentPath=",
        }
    }
    componentDidMount = () => {
        const { orderId } = this.props.match.params;
        if (this.props.history.location.state) {
            this.setState({ paymentHistoryDetail: this.props.history.location.state })
        } else {
            ApiCall(
                'GET',
                baseURL + SUBSCRIPTION_HISTORY_ENDPOINT,
                {},
                {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            ).then((data) => {
                if (data.flag != -1) {
                    if (data.flag == 500) {
                        console.log("in 500");
                    }
                    else {
                        console.log('I am 200!');
                        data.filter((name, index) => {
                            if (orderId == name.orderId) {
                                this.setState({ paymentHistoryDetail: name });
                            }
                        })
                    }
                }
            });
        }
    }
    downloadDocument = (path) => {
        const testAccess = Cookies.get('_msAL');
        let fileType = false;
        if (path) {
            var extensionType = path.substring(path.lastIndexOf(".") + 1, path.length);
            const extensionTypeF = extensionType.replace("')", "");
            if (['pdf', 'PDF', 'Pdf'].includes(extensionTypeF)) {
                fileType = true;
            }
        }
        //start loader
        store.dispatch(successLoader(false));
        var oReq = new XMLHttpRequest();
        var URLToPDF = this.state.documentURL + path;
        oReq.open("GET", URLToPDF, true);
        oReq.setRequestHeader("Authorization", 'Bearer' + ` ${testAccess}`);
        oReq.responseType = "blob";
        oReq.onload = function () {
            const file = new Blob([oReq.response],
                { type: fileType ? 'application/pdf' : "image/jpg" });
            const fileURL = URL.createObjectURL(file);
            //end loader
            store.dispatch(successLoader(true));
            window.open(fileURL, "_blank");
        };
        oReq.send();
    }
    render() {
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.paymentDetailsPageTitle} description={TitleDescription.paymentDetailsPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="pdcsnofull">
                    <div id="pdcsnobox1">
                        <div class="rnononavbar">
                            <div className="rnonavbarname">
                                <small id="nonavc">Subscription Details</small>
                            </div>
                        </div>
                        <hr class="hr1" />
                        <div class="managementmaincard">
                            <div>
                                <div class="mscarddiv2">
                                    <div class="pspsubhisdiv">
                                        <small class="mscarddivsm1">Order Details</small>
                                    </div>
                                    <div>
                                        <div class="pspmscardactive1order">
                                            <div class="pddivout1">
                                                <div class="pdconerow">
                                                    <small class="pddivsm1">Plan</small>
                                                    <small class="pddivsm2">{this.state.paymentHistoryDetail?.subscriptionPlan?.tenure}</small>
                                                </div>
                                                <div class="pdconerow">
                                                    <small class="pddivsm1">Order Date & Time</small>
                                                    <small class="pddivsm2">{FormatTimeStamp(this.state.paymentHistoryDetail?.orderDate).timedateToLocale}</small>
                                                </div>
                                                <div class="pdconerow">
                                                    <small class="pddivsm1">Order ID</small>
                                                    <small class="pddivsm2">{this.state.paymentHistoryDetail?.orderId}</small>
                                                </div>
                                            </div>
                                            <div class="pspdivout2">
                                                <div class="pdconerow">
                                                    <small class="pddivsm1">Order Total</small>
                                                    <small class="pddivsm2order">{this.state.paymentHistoryDetail?.subscriptionPlan?.totalAmount}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class='downloadDiv'>
                                    <div class="pdmscardactive1">
                                        <div class="pdconerow">
                                            <small class="pddivsm2">Download Invoice</small>
                                            <small class="pddivsm2">
                                                <Link onClick={() => this.downloadDocument(this.state.paymentHistoryDetail?.invoicePDF)}>
                                                    <img
                                                        src={download}
                                                        class="" id=""
                                                        alt="" loading="lazy"
                                                    />
                                                </Link>
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="mscarddiv2">
                                    <div class="pdsubhisdiv">
                                        <small class="mscarddivsm1">Payment Information</small>
                                    </div>
                                    <div>
                                        <div class="pdmscardactive1">
                                            <div class="pdconerow">
                                                <small class="pddivsm1">Payment Method</small>
                                                <small class="pddivsm2">{}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mscarddiv2">
                                    <div class="pdsubhisdiv">
                                        <small class="mscarddivsm1">Order Summary</small>
                                    </div>
                                    <div>
                                        <div class="pspmscardactive1">
                                            <div class="pddivout1">
                                                <div class="pdconerow">
                                                    <small class="pddivsm1">Total before VAT</small>
                                                    <small class="pddivsm2">R {this.state.paymentHistoryDetail?.subscriptionPlan?.amount}</small>
                                                </div>
                                                <div class="pdconerow">
                                                    <small class="pddivsm1">VAT (15%)</small>
                                                    <small class="pddivsm2">R {this.state.paymentHistoryDetail?.subscriptionPlan?.tax}</small>
                                                </div>
                                            </div>
                                            <div class="pspdivout2">
                                                <div class="pdconerow">
                                                    <small class="pddivsm1">Order Total</small>
                                                    <small class="pddivsm2order">{this.state.paymentHistoryDetail?.subscriptionPlan?.totalAmount}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pdpnotifooter01">
                    <Footer />
                </div>
                <div class="pdpnotifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default PaymentDetails;